import React from 'react';
import '../components/grammar-page.css';
import { FaBookOpen, FaListUl } from 'react-icons/fa';
const PresentperfectExplanation = () => {
  return (
    
      <div>
        <div>

<div>
                            <div className="grammar-explanation">

                            <div className="grammartext">
  <h2><FaBookOpen style={{ marginRight: '0.5rem' }} />Grammar explanation: Present Perfect</h2>
<p>We use the present perfect to connect the past with the present. It can describe actions that started in the past and continue now, or experiences that happened at an unspecified time.</p>



<h3><FaListUl style={{ marginRight: '0.5rem' }} />Uses</h3>
<ul>
  <li><strong>Stative verbs with for and since to show something started in the past and continues now.</strong>: Some verbs (called stative verbs) describe states, feelings, or possession rather than actions. 
    These are not usually used in the continuous form, so we often use the simple present perfect with them.<br/>
    <em>I have known her for 10 years.</em><br/>
    <em>They have always liked that restaurant.</em><br/>
    <br/>
    <u>Common stative verbs:</u> work, live, know, have, like, love, hate, want, need.
  </li>
  
  <li><strong>To say how many times</strong>: to describe repeated actions up to now.<br/>
    <em>I have seen that film three times.</em>
  </li>
  <li><strong>With ever/never</strong>: to talk about life experience.<br/>
    <em>Have you <strong>ever</strong> been to London?</em><br/>
    <em>I have <strong>never</strong> eaten sushi.</em>
  </li>
</ul>

<hr/>

<h2>Grammar explanation: Present Perfect Continuous</h2>
<p>We use the present perfect continuous to focus on the <strong>activity</strong> or <strong>duration</strong> of something that started in the past and continues now, or has just finished with a present result.</p>


<h3>Uses</h3>
<ul>
  <li><strong>Ongoing actions</strong>: started in the past and still happening.<br/>
    <em>She has been studying English for 2 years.</em>
  </li>
  <li><strong>Recent activity with present result</strong>: the action may have stopped, but the effect is visible now.<br/>
    <em>I’m tired because I have been running.</em>
  </li>
</ul>

<h3>Present Perfect vs Present Perfect Continuous</h3>
<ul>
  <li><strong>Present Perfect (focus on result):</strong> I have written 10 emails today. (completed result)</li>
  <li><strong>Present Perfect Continuous (focus on activity/duration):</strong> I have been writing emails all morning. (ongoing activity)</li>
</ul>

</div>

                            
                            
          </div>
        </div>
      </div>
    </div>
  );
};

export default PresentperfectExplanation;
